import WebsiteServiceModel from '@/models/WebsiteServiceModel';
import doc                 from '@widesk-core/decorators/doc';

export default class PlaceModel extends WebsiteServiceModel {
	private declare _tsFilters: {
		'id': id;
		'partial': string;
		'private': string;
		'existsInContentToPublish': string;
		'createdAt[before]': string | Date;
		'createdAt[strictly_before]': string | Date;
		'createdAt[after]': string | Date;
		'createdAt[strictly_after]': string | Date;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_before]': string | Date;
		'updatedAt[after]': string | Date;
		'updatedAt[strictly_after]': string | Date;
		'stand': id;
		'websiteEntertainment': id;
		'placeStatus': string;
		'planningPlaces.planning': id;
		'exists[stand]': string;
		'search': string;
		'slug': string;
	};

	private declare _tsSorts: {
		id: string;
		private: string;
		position: string;
		createdAt: string;
		updatedAt: string;
	};

	static get path(): string {
		return 'places/{?id}';
	}

	@doc.string declare slug: string;
	@doc.number declare position: number;
	@doc.string declare createdBy: string;
	@doc.string declare updatedBy: string;
	@doc.date declare createdAt: Dayjs;
	@doc.date declare updatedAt: Dayjs;

	getTitle(lang: string) {
		return this.getTranslation<string, string>('title', lang, '');
	}
}
